import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';



@Component({
  selector: 'app-booking-instruction',
  templateUrl: './booking-instruction.component.html',
  styleUrls: ['./booking-instruction.component.scss']
})
export class BookingInstructionComponent implements OnInit {
  @Input() flow = '';
  constructor(private commonservice: CommonService) { }


  bookingInfoData = [];
  cutoff: any = [];
  editcutoff: any = null;
  cancelcutoff: any = null;
  bookingTypes = [];
  citylist: any;
  firstCity = '';
  cities: DropdownItem[];
  emptyState = false;
  enableCityWiseCreationCutOff = false;
  bookingTypesNew: any;
  cutOffInstructions: any = [];
  instructionData: any;
  $destroy: Subject<void> = new Subject<void>();
  ngOnInit(): void {

    this.commonservice.fetchMiscConfig().subscribe(res =>
      this.enableCityWiseCreationCutOff = res?.enableCityWiseCreationCutOff
    );
    this.commonservice.fetchConfig().subscribe((response: any) => {
      const pageConfig = this.commonservice.getConfigForElementKey(response, 'Trip Details Form').elementConfigList;
      pageConfig.forEach(element => {
        if (element.elementKey == 'spotBookingType') {
          this.bookingTypesNew = element.config.values;
        }
        if (element.elementKey == 'city') {
          this.citylist = element.config.values;
          this.cities = this.citylist.map((item: any) => ({
            label: item,
            value: item,
          })).filter((item) => {
            return item.label !== "All";
          }).sort(
            (a, b) => (a.label > b.label) ? 1 : (a.label < b.label) ? -1 : 0
          );
          this.firstCity = this.cities[0].label;
        }
      });
      combineLatest([
       this.enableCityWiseCreationCutOff ? this.commonservice.cityCuttoffObj : this.commonservice.cuttoffObj,
        this.commonservice.editcuttoffObj,
        this.commonservice.cancelcuttoffObj
       ]).pipe(takeUntil(this.$destroy))
        .subscribe(([cutoff, editcutoff, cancelcutoff]) => {
          this.cutoff = cutoff ? cutoff : this.cutoff;
          this.editcutoff = editcutoff || this.editcutoff;
          this.cancelcutoff = cancelcutoff || this.cancelcutoff;
          if (this.enableCityWiseCreationCutOff) {
              this.createCityBookingInfo(this.cutoff, this.firstCity);
          }
          else
              if (this.cutoff.length > 0 && this.editcutoff && this.cancelcutoff) {
            this.createBookingInfo(this.cutoff);
              }
        });
    });


  }
  createBookingInfo(data) {
    this.cutOffInstructions = [];
    this.bookingTypesNew.forEach(bookingType => {
        data.forEach(type => {
          type.bookingTypes.forEach(booking => {
            if (this.getCombinedLowerString(booking).includes(this.getCombinedLowerString(bookingType))) {

              // name
              let displayName, icon, description;
              if (this.getCombinedLowerString(bookingType).includes('airport')) {
                icon = 'assets/ic-plane-24.svg';
                displayName = 'Airport Transfers';
                description = 'Book a cab for airport pickup or drop';
              }
              else if (this.getCombinedLowerString(bookingType).includes('outstation')) {
                icon = "assets/Group.svg";
                displayName = 'Outstation';
                description = 'Book cabs for travelling between cities ';
              }
              else if (this.getCombinedLowerString(bookingType) === 'localrental' ||  this.getCombinedLowerString(bookingType).includes('resident')) {
                icon = "assets/localRental.svg";
                displayName = 'Local Rental';
                description = 'Book cabs for local commute';
              }
              else if (this.getCombinedLowerString(bookingType).includes('hotel')) {
                icon = "assets/ic-nav-office-24.svg";
                displayName = 'Hotel Pickup/Drop';
                description = 'Book a cab for hotel pickup or drop';
              }
              else if (this.getCombinedLowerString(bookingType).includes('4')  || this.getCombinedLowerString(bookingType).includes('8') ||  this.getCombinedLowerString(bookingType).includes('12')  || this.getCombinedLowerString(bookingType).includes('disposal') || this.getCombinedLowerString(bookingType).includes('intercity')) {
                icon = 'assets/localRental.svg';
                displayName = 'Fixed price package cabs';
                description = 'Book cabs with fixed hourly packages';
              }
              // edit-cancel cutoff
              let statement;
              if (this.editcutoff == 0 && this.cancelcutoff == 0) { statement = 'Modify/Cancel bookings with no delay'; }
              else if (this.editcutoff == this.cancelcutoff) { statement = `Modify/Cancel bookings <b class="font-weight-700 color-181F33">${this.cutOffTimeFormatter(this.editcutoff)}</b> before pickup time`; }
              else if (this.editcutoff == 0 && this.cancelcutoff > 0) { statement = `Modify bookings with no delay while Cancellation is available <b class="font-weight-700 color-181F33">${this.cutOffTimeFormatter(this.cancelcutoff)}</b> before pickup time`; }
              else if (this.editcutoff > 0 && this.cancelcutoff > 0) { statement = `Modify/Cancel bookings <b class="font-weight-700 color-181F33">${this.cutOffTimeFormatter(this.editcutoff)}</b> and <b class="font-weight-700 color-181F33">${this.cutOffTimeFormatter(this.cancelcutoff)}</b>  before pickup time, respectively`; }
              else if (this.editcutoff > 0 && this.cancelcutoff == 0) { statement = `Modify bookings  <b class="font-weight-700 color-181F33">${this.cutOffTimeFormatter(this.editcutoff)}</b> before pickup time while Cancellation can be done with no delay`; }

              // detail
              this.cutOffInstructions.push(
                  {
                    displayName,
                    icon,
                    description,
                    instruction:
                      [
                        type.cutOffMins > 0 ? `Create Bookings <b class="font-weight-700 color-181F33">${this.cutOffTimeFormatter(type.cutOffMins)}</b> in advance` : 'Bookings can be Created with no delay',
                        statement
                      ]
                  }
              );
            }
          });
        });
      });

    this.instructionData = this.removeDuplicates(this.cutOffInstructions);



  }
  removeDuplicates(arr) {
    const uniqueArray = [];
    const mySet =  new Set();
    arr.forEach((item) => {
      const key = item.displayName;
      if (!mySet.has(key)) {
        mySet.add(key);
        uniqueArray.push(item);
      }
    });

    return uniqueArray;
  }
  createCityBookingInfo(data, city){
    const cityBookings = data[city];
    if (!cityBookings) {
    this.emptyState = true;
    return [];
   }
    this.emptyState = false;
    const filterData = this.createBookingInfo(cityBookings);
    return filterData;
  }
  getCombinedLowerString(type) {
    return type.split(' ').join('').toLowerCase();
  }
  citySelect(city){
    this.firstCity = city.label;
    this.createCityBookingInfo(this.cutoff, city.value);
  }

  cutOffTimeFormatter(time) {
    return time < 60 ? `${time} minutes` : `${time / 60} hours`;
  }
ngOnDestroy(): void {
  this.$destroy.next();
  this.$destroy.complete();
}

}
